export const header = {
    "home_page": "ໜ້າຫຼັກ",
    "study_program": "ຫຼັກສູດ",
    "study_program_sort": "ຫຼັກສູດ",
    "change_language": "ປ່ຽນ​ພາ​ສາ",
    "vietnamese": "ພາສາຫວຽດນາມ",
    "english": "ພາສາອັງກິດ",
};
